import { render, staticRenderFns } from "./systemDetail.vue?vue&type=template&id=7bd879c7"
import script from "./systemDetail.vue?vue&type=script&lang=js"
export * from "./systemDetail.vue?vue&type=script&lang=js"
import style0 from "./systemDetail.vue?vue&type=style&index=0&id=7bd879c7&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports